<template>
	<el-tabs type="card">
		<el-tab-pane label="活动内容">
			<div style="padding: 0px;">
				<el-form :inline="false" :disabled="true" :model="couponinfo" ref="couponrule" label-width="120px" class="">
					<el-form-item label="活动编码:" prop="code">
						{{couponinfo.code}}
						<!-- <el-input style="width: 50%;" clearable v-model="couponinfo.code" placeholder="请输入活动编码"></el-input> -->
					</el-form-item>
					<el-form-item label="活动类型:" prop="category">
						{{couponinfo.category == 'platform' ? '平台' : '商家'}}
					</el-form-item>
					<el-form-item v-show="couponinfo.category == 'business'" label="活动商家:" prop="businessname">
						{{couponinfo.businessname}}
					</el-form-item>
					<el-form-item v-show="couponinfo.category == 'business'" label="使用档口:" prop="stallname">
						{{couponinfo.stallname}}
					</el-form-item>
					<el-form-item label="发放数量:" prop="count">
						{{couponinfo.count}}
						<!-- <el-input-number style="" v-model="couponinfo.count" :precision="0" ></el-input-number> -->
					</el-form-item>
					<el-form-item label="已领取数量:" prop="linkcount">
						{{couponinfo.linkcount}}
						<!-- <el-input-number style="" v-model="couponinfo.linkcount" :precision="0" ></el-input-number> -->
					</el-form-item>
					<el-form-item label="已使用数量:" prop="usecount">
						{{couponinfo.usecount}}
						<!-- <el-input-number style="" v-model="couponinfo.usecount" :precision="0" ></el-input-number> -->
					</el-form-item>
					<el-form-item label="活动类型:" prop="type">
						{{couponinfo.typename}}
					    <!-- <el-radio-group v-model="couponinfo.type" >
							<el-radio label="cash">现金券</el-radio>
							<el-radio label="discount">折扣券</el-radio>
							<el-radio label="fullreduction">满减券</el-radio>
					    </el-radio-group> -->
					</el-form-item>
					<el-form-item v-show="couponinfo.type == 'cash'" label="抵扣金额:" prop="discount">
						{{couponinfo.discount}}
						<!-- <el-input-number style="" v-model="couponinfo.discount" :precision="0" ></el-input-number> -->
						元
					</el-form-item>
					<el-form-item v-show="couponinfo.type == 'discount'" label="折扣:" prop="percent">
						{{couponinfo.percent}}
						<!-- <el-input-number style="" v-model="couponinfo.percent" :precision="0" ></el-input-number> -->
						折
					</el-form-item>
					<el-form-item v-show="couponinfo.type == 'fullreduction'" label="满减:" >
						满{{couponinfo.full}}
						<!-- <el-input-number style="width: 200px;" v-model="couponinfo.full" :precision="2" ></el-input-number> -->
						元，减{{couponinfo.mins}}
						<!-- <el-input-number style="width: 200px;" v-model="couponinfo.mins" :precision="2"  ></el-input-number> -->元
					</el-form-item>
					
					<el-form-item label="活动日期:" prop="daterange">
						{{couponinfo.validtime}}
						<!-- <el-date-picker v-model="couponinfo.daterange" type="daterange"
							  start-placeholder="开始日期"  end-placeholder="结束日期" >
						</el-date-picker> -->
					</el-form-item>
				</el-form>
			</div>
		</el-tab-pane>
		<el-tab-pane label="领用详情">
			<div style="margin-top: 10px;">
				<el-table :data="couponsList"  style="width: 100%"  height="500">
					<el-table-column prop="Coupons_Code" label="编码" width="150" align="center"></el-table-column>
					<el-table-column prop="Coupons_Type" label="活动类型" width="120" align="center">
						<template slot-scope="scope">
							<span > {{ scope.row.Coupons_Type == 'cash' ? '现金券' : (scope.row.Coupons_Type == 'discount' ? '折扣券' : '满减券') }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="Coupons_State" label="状态" width="120" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.Coupons_State == 'notlink'" type="">未领取</el-tag>
							<el-tag v-else-if="scope.row.Coupons_State == 'notuse'" type="success">未使用</el-tag>
							<el-tag v-else-if="scope.row.Coupons_State == 'used'" type="info">已使用</el-tag>
							<el-tag v-else-if="scope.row.Coupons_State == 'overd'" type="danger">已过期</el-tag>
							<el-tag v-else-if="scope.row.Coupons_State == 'stop'" type="warning">已暂停</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="CustomName" label="领用人" width="120" align="center"></el-table-column>
					<el-table-column prop="OrderNo" label="使用订单" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="text-align: center;">
				<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
					:page-size="param.pagenum" :total="couponsTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
			</div>
		</el-tab-pane>
	</el-tabs>
	
</template>

<script>
	import { queryCouponsDetailList } from '/static/apiUrl.js'
	export default {
		name : 'CouponsDetail',
		data() {
			return {
				couponsTotal : 0,
				couponinfo : {
					code : '',
					type : '',
					typename : '',
					businessname : '',
					stallname : '',
					category : '',
					userange : '',
					count : 0,
					linkcount : 0,
					usecount : 0,
					validtime : '',
					content : '',
					discount : 0,
					percent : 0,
					fullreduct : 0,
					daterange : ''
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				couponsList : [
					/* {
						code : 'PT-0001',
						type : 'cash',
						typename : '现金',
						statename : '已领取',
						state : '',
						linkusername : '霜',
						linkorderno : ''
					} */
				]
			}
		},
		mounted() {
			
		},
		props: {
			info : {
				type: Object,
				required: false
			},
			
		},
		watch: {
			info: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.couponinfo = newVal
					let tmp = newVal.validtime.split(' ~ ')
					this.couponinfo.daterange = [tmp[0],tmp[1]]
					this.couponsList = []
					this.initData()
				}
			},
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.initData()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.initData()
			},
			initData(){
				queryCouponsDetailList({
					usrId: "",
					code: this.couponinfo.code,
					state: "",
					pageIndex: this.param.page,
					pageSize: this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.couponsTotal = res.data.total
						this.couponsList = res.data.data
					}
				})
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>